export const parenthesesContent = /\(([^)]+)\)/;

export const bracketContent = /\[(.*?)\]/;

export const email = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
export const isValidEmail = (str) => str && str.match(email);

export const numeric = /^[0-9]*$/;
export const isNumeric = (str) => str && numeric.test(str);
